import { render, staticRenderFns } from "./UdlAdaptationPanelGroup.vue?vue&type=template&id=ba6aa0a4&scoped=true"
import script from "./UdlAdaptationPanelGroup.vue?vue&type=script&lang=js"
export * from "./UdlAdaptationPanelGroup.vue?vue&type=script&lang=js"
import style0 from "./UdlAdaptationPanelGroup.vue?vue&type=style&index=0&id=ba6aa0a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6aa0a4",
  null
  
)

export default component.exports